// @flow
import clone from 'ramda/es/clone';
import values from 'ramda/es/values';
import path from 'ramda/es/path';

import action from 'app/common/lib/action';
import api from 'app/actions/api';


const requestEmployeeUuid = async (employeeId: number, dispatch: Function): Promise<string | null> => {
  const requestPath = `cabinet/employees/${employeeId}`;

  try {
    const res = await api(requestPath, 'get');
    const employees = values(path(['data', 'employees'], res));
    return path([0, 'user_uuid'], employees) || null;
  } catch (error) {
    const errorSave = {
      // err: '',  // ошибку не отображаем
      path: requestPath,
      error: clone(error),
    };
    dispatch(action('REQUEST_FAILURE', errorSave));
    return null;
  }
};

export default requestEmployeeUuid;
